module.exports = __webpack_public_path__ + "img/covid.90fbe424.png";